import React, { useContext, useState, useEffect, useRef } from "react";
import { AuthContext } from "../../../common/Auth"
import axios from 'axios'
import { makeStyles, Select, Switch, MenuItem, Checkbox, FormControl, List, ListItemText } from "@material-ui/core";
import { THEME_URL, X_TENANT_ID, ALL_TAGS_URL } from '../../../common/ActionUrl'
import { _useToasts } from "../../../common/_useToasts";
import { useNavigate } from "react-router-dom";
import { USERTYPES } from "../../../constant/userType"
import ColorPicker from "material-ui-color-picker";
import { FONT_FAMILY, TITLE_BORDER, CLASSNAME_P_B, CLASSNAME_P_R, CLASSNAME_P_L, CLASSNAME_P_T, CLASSNAME_M_B, CLASSNAME_M_R, CLASSNAME_M_L, CLASSNAME_M_T } from '../../../constant/bannerItems'
import DeleteIcon from '@material-ui/icons/Delete';
import JoditEditor from "jodit-react";
import TextEditorConfig from "../../../helpers/TextEditor";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        className: "col-12",
        maxWidth: 600,
        backgroundColor: theme.palette.background.paper,
    }
}));

const ProductSliderSetting = ({ setTabName, tabName, handleClose }) => {
    const [formStates, setFormStates] = useState({
        sectionTitle: "Our Products",
        sectionTitleColor: "",
        sectionTitleFont: "",
        sectionTitleFontSize: "",
        sectionTitlePosition: "",
        sectionTitleEnabled: true,
        sectionSubTitle: "",
        sectionSubTitleColor: "",
        sectionSubTitleFont: "",
        sectionSubTitleFontSize: "",
        sectionSubTitlePosition: "",
        sectionSubTitleEnabled: true,
        sectionTitleBorder: "",
        paddingTop: "", paddingBottom: "", marginTop: "", marginBottom: "", marginRight: "", marginLeft: "", paddingRight: "", paddingLeft: "", fullSection: false
    });
    const navigate = useNavigate();
    const { _addToast } = _useToasts();

    const { user, userType, getThemeSettings } = useContext(AuthContext)
    const adminUserId = user?.userId

    const editor = useRef(null)
    const [temp, setTemp] = useState("")

    const [themeId, setThemeId] = useState("")
    const [themeData, setThemeData] = useState({})
    const [tagData, setTagsData] = useState([])
    const [toggle, setToggle] = useState(false)
    useEffect(() => {
        if (Object.keys(themeData).length > 0) {
            let themeSettingData = themeData.filter(themeArray => themeArray.settingsName === "productSlider")
            if (themeSettingData[0]) {
                formStates.sectionTitle = themeSettingData[0].values[0].sectionTitle ? themeSettingData[0].values[0].sectionTitle : ""
                formStates.sectionTitleEnabled = themeSettingData[0].values[0].sectionTitleEnabled ? themeSettingData[0].values[0].sectionTitleEnabled : ""
                formStates.sectionSubTitle = themeSettingData[0].values[0].sectionSubTitle ? themeSettingData[0].values[0].sectionSubTitle : ""
                formStates.sectionSubTitleEnabled = themeSettingData[0].values[0].sectionSubTitleEnabled ? themeSettingData[0].values[0].sectionSubTitleEnabled : ""
                formStates.sectionTitleColor = themeSettingData[0].values[0].sectionTitleColor ? themeSettingData[0].values[0].sectionTitleColor : ""
                formStates.sectionTitleFont = themeSettingData[0].values[0].sectionTitleFont ? themeSettingData[0].values[0].sectionTitleFont : ""
                formStates.sectionTitleFontSize = themeSettingData[0].values[0].sectionTitleFontSize ? themeSettingData[0].values[0].sectionTitleFontSize : ""
                formStates.sectionTitlePosition = themeSettingData[0].values[0].sectionTitlePosition ? themeSettingData[0].values[0].sectionTitlePosition : ""
                formStates.sectionSubTitleColor = themeSettingData[0].values[0].sectionSubTitleColor ? themeSettingData[0].values[0].sectionSubTitleColor : ""
                formStates.sectionSubTitleFont = themeSettingData[0].values[0].sectionSubTitleFont ? themeSettingData[0].values[0].sectionSubTitleFont : ""
                formStates.sectionSubTitleFontSize = themeSettingData[0].values[0].sectionSubTitleFontSize ? themeSettingData[0].values[0].sectionSubTitleFontSize : ""
                formStates.sectionSubTitlePosition = themeSettingData[0].values[0].sectionSubTitlePosition ? themeSettingData[0].values[0].sectionSubTitlePosition : ""
                formStates.sectionTitleBorder = themeSettingData[0].values[0].sectionTitleBorder ? themeSettingData[0].values[0].sectionTitleBorder : ""
                formStates.marginTop = themeSettingData[0].values[0].marginTop ? themeSettingData[0].values[0].marginTop : ""
                formStates.marginBottom = themeSettingData[0].values[0].marginBottom ? themeSettingData[0].values[0].marginBottom : ""
                formStates.marginRight = themeSettingData[0].values[0].marginRight ? themeSettingData[0].values[0].marginRight : ""
                formStates.marginLeft = themeSettingData[0].values[0].marginLeft ? themeSettingData[0].values[0].marginLeft : ""
                formStates.paddingRight = themeSettingData[0].values[0].paddingRight ? themeSettingData[0].values[0].paddingRight : ""
                formStates.paddingLeft = themeSettingData[0].values[0].paddingLeft ? themeSettingData[0].values[0].paddingLeft : ""
                formStates.paddingTop = themeSettingData[0].values[0].paddingTop ? themeSettingData[0].values[0].paddingTop : ""
                formStates.paddingBottom = themeSettingData[0].values[0].paddingBottom ? themeSettingData[0].values[0].paddingBottom : ""
                formStates.fullSection = themeSettingData[0].values[0].fullSection ? themeSettingData[0].values[0].fullSection : ""

                setThemeId(themeSettingData[0]._id)
                setToggle(!toggle)
            }
        }
    }, [themeData, tagData])
    const handleInputChange = (e, key) => {
        let tempData = { ...formStates }
        tempData[key] = e.target.value
        setFormStates(tempData)
    }
    const handleCheckboxInputChange = (event) => {
        setFormStates(formStates => ({ ...formStates, [event.target.name]: event.target.checked }));
    }
    const handleInputSwitchChange = (e, key) => {
        let tempData = { ...formStates }
        if (e.target.checked) {
            tempData[key] = true
        } else {
            tempData[key] = false
        }
        setFormStates(tempData)
    }

    const getTags = () => {
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        axios.get(ALL_TAGS_URL + "?limit=500&offset=0&order=tagName&orient=asc", requestOptions)
            .then(res => {
                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    if (res.data && res.data.results.length > 0) {
                        setTagsData(res.data.results)
                    }
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    }
    const getThemeId = () => {
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        axios.get(THEME_URL, requestOptions)
            .then(res => {

                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    if (res.data) {
                        setThemeData(res.data)
                    }
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    }
    const handleColorPicker = (e, key) => {
        let tempData = { ...formStates }
        tempData[key] = e
        setFormStates(tempData)
    }
    const resetColor = (value, key) => {
        let tempData = { ...formStates }
        tempData[key] = value
        setFormStates(tempData)
    }
    useEffect(() => {
        getThemeId()
        getTags()
    }, []);

    async function createUserCallback() {

        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        let insertData = {
            settingsName: "productSlider",
            "values": {
                "sectionTitle": formStates.sectionTitle,
                "sectionTitleEnabled": formStates.sectionTitleEnabled,
                "sectionSubTitle": formStates.sectionSubTitle,
                "sectionSubTitleEnabled": formStates.sectionSubTitleEnabled,
                "sectionTitleColor": formStates.sectionTitleColor,
                "sectionTitleFont": formStates.sectionTitleFont,
                "sectionTitleFontSize": formStates.sectionTitleFontSize,
                "sectionTitlePosition": formStates.sectionTitlePosition,
                "sectionSubTitleColor": formStates.sectionSubTitleColor,
                "sectionSubTitleFont": formStates.sectionSubTitleFont,
                "sectionSubTitleFontSize": formStates.sectionSubTitleFontSize,
                "sectionSubTitlePosition": formStates.sectionSubTitlePosition,
                "sectionTitleBorder": formStates.sectionTitleBorder,
                "marginTop": formStates.marginTop,
                "marginBottom": formStates.marginBottom,
                "marginRight": formStates.marginRight,
                "marginLeft": formStates.marginLeft,
                "paddingRight": formStates.paddingRight,
                "paddingLeft": formStates.paddingLeft,
                "paddingTop": formStates.paddingTop,
                "paddingBottom": formStates.paddingBottom,
                "fullSection": formStates.fullSection,
                "createdBy": adminUserId
            }, userId: adminUserId
        }
        if (themeId) {
            axios.patch(THEME_URL + themeId, insertData, requestOptions)
                .then(res => {
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        getThemeSettings()
                        handleClose()
                        _addToast("Theme updated successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });
                    }
                }).catch((error, config, code, request, response) => {
                    if (error.response && error.response.data.statusCode === 409) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast("Issues while update theme", {
                            appearance: "error",
                            autoDismiss: true
                        });
                    }
                });
        } else {
            axios.post(THEME_URL, insertData, requestOptions)
                .then(res => {
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        getThemeSettings()
                        handleClose()
                        _addToast("Theme added successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });
                    }
                })
                .catch((error, config, code, request, response) => {
                    if (error.response && error.response.data.statusCode === 409) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else if (error.response && error.response.data.statusCode === 400) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast("Issues while create theme", {
                            appearance: "error",
                            autoDismiss: true
                        });
                    }
                });
        }
    }
    const classes = useStyles();
    return (

        <div className="contact-area pt-10 pb-10">
            <div className="banner-form" style={{ 'minHeight': '50vh' }}>
                {userType !== USERTYPES.USER ?
                    <form className="banner-form-style" >
                        <div className="col-md-12">
                            <div className="row inputRow">
                                <div className="col-md-4 form-group">
                                    <label>Section Title</label>
                                    <Switch color="primary" checked={formStates.sectionTitleEnabled} onChange={(e) => handleInputSwitchChange(e, "sectionTitleEnabled")} />
                                </div>
                                <div className="col-md-8 form-group">
                                    <JoditEditor
                                        ref={editor}
                                        value={formStates.sectionTitle}
                                        config={TextEditorConfig}
                                        tabIndex={1}
                                        onChange={(bodyOfEditor) => {
                                            formStates.sectionTitle = bodyOfEditor
                                            setTemp('0');
                                        }}
                                    />

                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Section Title Color</label>
                                </div>
                                <div className="col-lg-2">
                                    <ColorPicker
                                        name="sectionTitleColor"
                                        defaultValue="Select color"
                                        value={formStates.sectionTitleColor}
                                        onChange={color => { handleColorPicker(color, 'sectionTitleColor') }}
                                    />
                                </div>
                                <div className="col-lg-3 d-flex align-items-center">
                                    <p>{formStates.sectionTitleColor != "undefined" && (formStates.sectionTitleColor)}</p>
                                    {formStates.sectionTitleColor != "undefined" &&
                                        formStates.sectionTitleColor != undefined &&
                                        formStates.sectionTitleColor != "" && (
                                            <DeleteIcon
                                                className="text-error ml-50 mb-10"
                                                title={"Reset Section Title color"}
                                                onClick={() => {
                                                    resetColor("", 'sectionTitleColor')
                                                }}
                                                aria-label=""
                                            />)}
                                </div>

                                <div className="col-md-4 form-group">
                                    <label>Section Title Font</label>

                                </div>
                                <div className="col-md-8 form-group">

                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.sectionTitleFont == "" ? " " : formStates.sectionTitleFont}
                                            onChange={(e) => handleInputChange(e, "sectionTitleFont")}
                                            name="sectionTitleFont">
                                            <MenuItem value=" ">Default</MenuItem>
                                            {FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
                                            })}
                                            {!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Section Title Font Size</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <input type="number" className={'form-control input-border'} onChange={(e) => handleInputChange(e, "sectionTitleFontSize")} value={formStates.sectionTitleFontSize} aria-describedby="sectionTitleFontSize" />
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Section Title Position</label>
                                </div>
                                <div className="col-md-8 form-group">

                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.sectionTitlePosition ? formStates.sectionTitlePosition : "text-center"}
                                            onChange={(e) => handleInputChange(e, "sectionTitlePosition")}
                                            name="sectionTitlePosition">
                                            <MenuItem value="text-center">Center</MenuItem>
                                            <MenuItem value="text-left">Left</MenuItem>
                                            <MenuItem value="text-right">Right</MenuItem>
                                        </Select>

                                    </FormControl>
                                </div>

                                <div className="col-md-4 form-group">
                                    <label>Section Title Border</label>
                                </div>
                                <div className="col-md-8 form-group">

                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.sectionTitleBorder}
                                            onChange={(e) => handleInputChange(e, "sectionTitleBorder")}
                                            name="sectionTitleBorder">
                                            {TITLE_BORDER && TITLE_BORDER.length && Object.keys(TITLE_BORDER).map((data, index) => {
                                                return <MenuItem value={TITLE_BORDER[data].value}> {TITLE_BORDER[data].label}</MenuItem>
                                            })}
                                            {!TITLE_BORDER.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>

                                    </FormControl>
                                </div>
                            </div>
                            <div className="row inputRow">
                                <div className="col-md-4 form-group">
                                    <label>Section Sub Title</label>
                                    <Switch color="primary" checked={formStates.sectionSubTitleEnabled} onChange={(e) => handleInputSwitchChange(e, "sectionSubTitleEnabled")} />
                                </div>
                                <div className="col-md-8 form-group">
                                    <JoditEditor
                                        ref={editor}
                                        value={formStates.sectionSubTitle}
                                        config={TextEditorConfig}
                                        tabIndex={1}
                                        onChange={(bodyOfEditor) => {
                                            formStates.sectionSubTitle = bodyOfEditor
                                            setTemp('0');
                                        }}
                                    />
                                </div>

                                <div className="col-md-4 form-group">
                                    <label>Section Sub Title Color</label>
                                </div>
                                <div className="col-lg-2">
                                    <ColorPicker
                                        name="sectionSubTitleColor"
                                        defaultValue="Select color"
                                        value={formStates.sectionSubTitleColor}
                                        onChange={color => { handleColorPicker(color, 'sectionSubTitleColor') }}
                                    />
                                </div>
                                <div className="col-lg-3 d-flex align-items-center">
                                    <p>{formStates.sectionSubTitleColor != "undefined" && (formStates.sectionSubTitleColor)}</p>
                                    {formStates.sectionSubTitleColor != "undefined" &&
                                        formStates.sectionSubTitleColor != undefined &&
                                        formStates.sectionSubTitleColor != "" && (

                                            <DeleteIcon
                                                className="text-error ml-50 mb-10"
                                                title={"Reset Section Title color"}
                                                onClick={() => {
                                                    resetColor("", 'sectionSubTitleColor')
                                                }}
                                                aria-label=""
                                            />)}
                                </div>


                                <div className="col-md-4 form-group">
                                    <label>Section Sub Title Font</label>
                                </div>
                                <div className="col-md-8 form-group">

                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.sectionSubTitleFont == "" ? " " : formStates.sectionSubTitleFont}
                                            onChange={(e) => handleInputChange(e, "sectionSubTitleFont")}
                                            name="sectionSubTitleFont">
                                            <MenuItem value=" ">Default</MenuItem>
                                            {FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
                                            })}
                                            {!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
                                        </Select>

                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Section Sub Title Font Size</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <input type="number" className={'form-control input-border'} onChange={(e) => handleInputChange(e, "sectionSubTitleFontSize")} value={formStates.sectionSubTitleFontSize} aria-describedby="sectionSubTitleFontSize" />
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Section Sub Title Position</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.sectionSubTitlePosition ? formStates.sectionSubTitlePosition : "text-center"}
                                            onChange={(e) => handleInputChange(e, "sectionSubTitlePosition")}
                                            name="sectionSubTitlePosition">
                                            <MenuItem value="text-center">Center</MenuItem>
                                            <MenuItem value="text-left">Left</MenuItem>
                                            <MenuItem value="text-right">Right</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Margin Top</label>

                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.marginTop}
                                            onChange={(e) => handleInputChange(e, "marginTop")}
                                            name="marginTop">
                                            {CLASSNAME_M_T && CLASSNAME_M_T.length && Object.keys(CLASSNAME_M_T).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_M_T[data].label }} value={CLASSNAME_M_T[data].value}> {CLASSNAME_M_T[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Margin Bottom</label>

                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.marginBottom}
                                            onChange={(e) => handleInputChange(e, "marginBottom")}
                                            name="marginBottom">
                                            {CLASSNAME_M_B && CLASSNAME_M_B.length && Object.keys(CLASSNAME_M_B).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_M_B[data].label }} value={CLASSNAME_M_B[data].value}> {CLASSNAME_M_B[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Margin Left</label>

                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.marginLeft}
                                            onChange={(e) => handleInputChange(e, "marginLeft")}
                                            name="marginLeft">
                                            {CLASSNAME_M_L && CLASSNAME_M_L.length && Object.keys(CLASSNAME_M_L).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_M_L[data].label }} value={CLASSNAME_M_L[data].value}> {CLASSNAME_M_L[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Margin Right</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.marginRight}
                                            onChange={(e) => handleInputChange(e, "marginRight")}
                                            name="marginRight">
                                            {CLASSNAME_M_R && CLASSNAME_M_R.length && Object.keys(CLASSNAME_M_R).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_M_R[data].label }} value={CLASSNAME_M_R[data].value}> {CLASSNAME_M_R[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Padding Top</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.paddingTop}
                                            onChange={(e) => handleInputChange(e, "paddingTop")}
                                            name="paddingTop">
                                            {CLASSNAME_P_T && CLASSNAME_P_T.length && Object.keys(CLASSNAME_P_T).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_P_T[data].label }} value={CLASSNAME_P_T[data].value}> {CLASSNAME_P_T[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Padding Bottom</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.paddingBottom}
                                            onChange={(e) => handleInputChange(e, "paddingBottom")}
                                            name="paddingBottom">
                                            {CLASSNAME_P_B && CLASSNAME_P_B.length && Object.keys(CLASSNAME_P_B).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_P_B[data].label }} value={CLASSNAME_P_B[data].value}> {CLASSNAME_P_B[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Padding Left</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.paddingLeft}
                                            onChange={(e) => handleInputChange(e, "paddingLeft")}
                                            name="paddingLeft">
                                            {CLASSNAME_P_L && CLASSNAME_P_L.length && Object.keys(CLASSNAME_P_L).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_P_L[data].label }} value={CLASSNAME_P_L[data].value}> {CLASSNAME_P_L[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Padding Right</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <FormControl variant="outlined" className='w-100'>
                                        <Select labelId="demo-simple-select-outlined-label" value={formStates.paddingRight}
                                            onChange={(e) => handleInputChange(e, "paddingRight")}
                                            name="paddingRight">
                                            {CLASSNAME_P_R && CLASSNAME_P_R.length && Object.keys(CLASSNAME_P_R).map((data, index) => {
                                                return <MenuItem style={{ fontFamily: CLASSNAME_P_R[data].label }} value={CLASSNAME_P_R[data].value}> {CLASSNAME_P_R[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-md-4 form-group">
                                    <label>Full section</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <Checkbox checked={formStates.fullSection} onChange={handleCheckboxInputChange} name="fullSection" className="ml-2 mt-1" />
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-12">
                            <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                            <button className="bannerbutton" type="button" onClick={() => { createUserCallback() }}>{themeId ? "Update" : "Save"}</button>
                        </div>
                    </form>
                    : ""}
            </div>
        </div>
    );
};

export default (ProductSliderSetting);
